import { createContext, useState, useContext, ReactNode } from "react";
import { AskResponse } from "../api";

interface Props {
    children?: ReactNode;
}

interface chatData {
    answers?: [user: string, response: AskResponse][];
    answersCleaned?: boolean;
    cleanAnswers?: Function;
    putAnswer?: Function;
    removeChatData?: Function;
    isLoading?: boolean;
    loading?: Function;
    linkToken?: string;
    putLinkToken?:Function;
    removeLinkToken?:Function;
    inputDisabled?:boolean;
    putInputDisabled?:Function;
}

const ChatContext = createContext<chatData>({});

export const useChat = () => {
    const chatData = useContext(ChatContext);
    return chatData;
};

export const ChatProvider = ({ children }: Props) => {
    const [answers, setAnswers] = useState<[user: string, response: AskResponse][]>([]);
    const [answersCleaned, setAnwersCleaned] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [linkToken, setLinksToken] = useState<string>('');
    const [inputDisabled, setInputDisabled] = useState<boolean>(false);

    const cleanAnswers = (signal: boolean) => {
        setAnwersCleaned(signal);
    };

    const putInputDisabled = (signal:boolean) => {
        setInputDisabled(signal);
    };

    const putAnswer = (question: string, result: AskResponse) => {
        setAnswers([...answers, [question, result]]);
    };

    const removeChatData = (Funct: Function) => {
        Funct();
        setAnswers([]);
    };
    const loading = (signal: boolean) => {
        setIsLoading(signal);
    };

    const putLinkToken = (link: string) =>  {
        setLinksToken(link)
    }

    const removeLinkToken = () => {
        setLinksToken('')
    }
    const values = {
        answers: answers,
        answersCleaned: answersCleaned,
        cleanAnswers: cleanAnswers,
        putAnswer: putAnswer,
        removeChatData: removeChatData,
        loading: loading,
        isLoading: isLoading,
        linkToken: linkToken,
        putLinkToken: putLinkToken,
        removeLinkToken: removeLinkToken,
        inputDisabled: inputDisabled,
        putInputDisabled: putInputDisabled
    };
    return <ChatContext.Provider value={values}>{children}</ChatContext.Provider>;
};
